
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import Header from "@/components/base/table/header/kunming/TitleHeader.vue";
import { Action, Getter } from "vuex-class";
import Table from "@/components/base/table/body/TableBoxText.vue";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { deepClone, getParentArea } from "@/common/utils";
@Component({
  name: "Apply",
  components: {
    Marquee,
    Header,
    Table,
    Pagination,
  },
})
export default class Apply extends Vue {
  @Action("policy/getApplyList") private getApplyList: any;
  @Getter("cityName") private cityName: any;
  @Getter("cityId") private cityId: any;
  @Getter("provinceId") private provinceId: any;
  searchProjectTitleValue: any = "";
  areaOption = this.$root.$data.areaOption;
  loading = false;
  tableData: any = [
    {
      depart: "工业和信息化局",
      according: "支持2020年昆明市专精特新中小企业发展方案",
      title: "无申请兑现   2020年昆明市专精特新中小企业奖励",
    },
    {
      depart: "知识产权局",
      according: "进一步加强知识产权运用和保护促进办法",
      title: "无申请兑现 知识产权维权援助和保护工作站补贴",
    },
    {
      depart: "科技局",
      according: "昆明市瞪羚企业认定扶持办法",
      title: "无申请兑现 瞪羚专项扶持资金（直接认定奖励）",
    },
    {
      depart: "商务局",
      according: "进一步促进现代服务业发展办法",
      title: "无申请兑现 服务外包行业权威荣誉认定奖励（现代服务业10条2.0）",
    },
    {
      depart: "科技局",
      according: "促进高新技术产业发展办法",
      title: "无申请兑现 高新技术企业落户奖励余款（黄金10条）",
    },
    {
      depart: "科技局",
      according: "昆明市瞪羚企业认定扶持办法",
      title: "无申请兑现 瞪羚专项扶持资金（独角兽成长奖）",
    },
    {
      depart: "金融局",
      according: "促进绿色金融发展政策措施",
      title: "无申请兑现 绿色企业上市奖励（辅导验收奖励、成功上市奖励部分）",
    },
    {
      depart: "发展改革局",
      according: "昆明市促进总部经济发展暂行办法的通知",
      title: "无申请兑现 广州市总部企业奖励补贴资金",
    },
    {
      depart: "金融局",
      according: "促进金融业发展政策措施",
      title:
        "无申请兑现 上市奖励（辅导验收奖励、成功上市奖励部分） （金融 10 条）",
    },
  ];
  searchValue: any = "";
  total = 0;
  pages = 0;
  current = 1;
  size = 12;
  current_option: any = {};
  created() {
    // this.getData(0);
  }
  handleClickNone() {}
  tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 === 1) {
      return "success-row";
    } else if (rowIndex % 2 === 0) {
      return "warning-row";
    }
    return "";
  }
  currentChange(params: any) {
    this.current = params;
    this.getData(1);
  }
  async getData(type: any) {
    // 0-default|1-search
    this.loading = true;
    const { centerId, provinceId, cityId, cityList } =
      this.$root.$data.currentAreaProps;
    const allArea = cityList.concat([centerId, provinceId, cityId]);
    let options: any = {
      current: this.current,
      size: this.size,
      addressCodeList: allArea,
    };
    this.current_option.addressCodeList = allArea;
    if (type === 1) {
      if (options.addressCode || this.current_option.addressCode) {
        this.current_option.addressCodeList = null;
      }
      options.addressCodeList = null;
      options = {
        ...options,
        ...this.current_option,
      };
    }
    setTimeout(() => {
      this.loading = false;
    }, 30000);
    this.getApplyList(options)
      .then(({ code, data, msg }: any) => {
        if (code === 0) {
          this.loading = false;
          const { total, records, pages } = data;
          const policy_arr: any = [];
          this.tableData = records.map(
            ({
              dispatchDirection,
              supportAmount,
              title,
              department,
              ...item
            }: any) => {
              const depart = department.departmentName || null;
              return {
                depart,
                title: `${title}(${dispatchDirection})`,
                tags: [dispatchDirection, supportAmount],
                ...item,
              };
            }
          );
          this.total = total;
          this.pages = pages;
        }
      })
      .catch((err: any) => err);
  }
  clickMarquee(options: any) {
    options.addressCode ? options.addressCode : this.cityId;
    this.current_option = options;
    this.getData(1);
  }
  search(options: any) {
    this.current_option = {
      ...this.current_option,
      ...options,
    };
    this.getData(1);
  }
  toDetail({ directionId, projectId }: any) {
    this.$router.push({
      path: "/detail/apply",
      query: {
        directionId,
        projectId,
      },
    });
  }
}
